export default __webpack_public_path__ + "static/media/Indice-di-massa-corporea1.a88fa90c.svg";